// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { useInvestmentExperience } from './use-investment-experience';
import {
  ScreenLayout,
  NavigationControls,
  ScreenHeader,
} from '@shared/advisory/account-workflow/layout';
import { Translation } from '@shared/ui-kit/providers';
import { type Path } from 'react-hook-form';
import type { InvestmentExperienceFormData } from '@shared/advisory/account-workflow/types';
import { QuestionCard } from '@shared/advisory/account-workflow/components/shared/question-card';

export const InvestmentExperience = defineComponent({
  displayName: 'InvestmentExperience',
  useSetup: useInvestmentExperience,
  View: ({ form, onNext, isFormValid, questions, isLoading }) => {
    return (
      <ScreenLayout
        actions={
          <NavigationControls
            form="investment-experience-form"
            isFormValid={isFormValid}
            loading={isLoading}
          />
        }
      >
        <div className="w-full max-w-4xl">
          <ScreenHeader
            title={
              <Translation
                i18nKey="investment-experience-header.title"
                ns="components"
              />
            }
            subtitle={
              <Translation
                i18nKey="investment-experience-header.subtitle"
                ns="components"
              />
            }
            className="mb-7"
            data-testid="header"
          />

          <form
            id="investment-experience-form"
            onSubmit={form.handleSubmit(onNext)}
            className="flex flex-col gap-4"
          >
            {questions.map(question => (
              <QuestionCard
                key={question.id}
                question={question}
                control={form.control}
                name={question.id as Path<InvestmentExperienceFormData>}
              />
            ))}
          </form>
        </div>
      </ScreenLayout>
    );
  },
});
